import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { InsightScreen } from "../../screens/insights/InsightScreen.tsx";
import { fromOf } from "../../screens/insights/insight-from.ts";
import { type PaneSearch, parsePaneSearch } from "../../screens/source/search.ts";

/** `/insights/$insightId`: one insight. `?from=` is the Insights tab it was opened from. */
export const Route = createFileRoute("/_app/insights/$insightId")({
  // the open panel (Source, Activity, or a block's Source and Explore with the block it points at), and the tab
  validateSearch: (s: Record<string, unknown>): PaneSearch => {
    const from = fromOf(s.from);
    return { ...parsePaneSearch(s), ...(from ? { from } : {}) };
  },
  loader: ({ context, params }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("insights.get", { insightId: params.insightId })),
  component: InsightScreen,
});
